import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { computed, action, makeAutoObservable } from 'mobx';
import { ModelsState } from 'src/AppState/Models/ModelsState';
import { PaymentProvidersType } from 'src/AppState/ConfigState/types';
import { getSavedCards } from 'src_server/types';
import { SavedCardInterface } from 'src_server/types/getSavedCards';
import { DefaultYaspaMethod } from 'src/components/PaymentMethodDropdown/PaymentMethodDropdown';

export class PaymentMethodDropdownState {
    public readonly selectedTopUpOption: FormInputState<string, string>;

    public constructor(
        private readonly models: ModelsState,
        private readonly customerId: number,
        private readonly usePaymentFormForUniverse: PaymentProvidersType
    ) {
        this.selectedTopUpOption = FormInputState.new('');
        makeAutoObservable(this);
    }

    @computed public get paymentMethodsValue(): string {
        const selectedPaymentMethod = this.selectedPaymentMethod;
        if (selectedPaymentMethod === undefined) {
            return 'none';
        }

        return selectedPaymentMethod.id;
    }

    @computed public get savedPaymentMethods(): SavedCardInterface[] {
        const pspRequest =
            this.models
                .getUserModel(this.customerId)
                .listCards.cardListAutoMap.get(this.usePaymentFormForUniverse.type)
                .getReady() ?? undefined;

        const pspCards = pspRequest?.responseStatus === 'success' ? pspRequest.response : [];

        const yaspaRequest =
            this.models.getUserModel(this.customerId).listCards.cardListAutoMap.get('yaspa').getReady() ?? undefined;

        const yaspaCards = yaspaRequest?.responseStatus === 'success' ? [DefaultYaspaMethod] : [];

        return [...yaspaCards, ...pspCards];
    }

    @computed public get isOpenBankingEnabled(): boolean {
        const cards = this.models.getUserModel(this.customerId).listCards.cardListAutoMap.get('yaspa').getReady();

        if (cards === null || cards.responseStatus === 'error') {
            return false;
        }

        return cards.response.length > 0;
    }

    @computed public get selectedPaymentMethod(): getSavedCards.SavedCardInterface | undefined {
        if (this.selectedTopUpOption.value === '') {
            const ArrLength = this.savedPaymentMethods.length;
            const lastSavedPaymentMethod = this.savedPaymentMethods[ArrLength - 1];

            if (lastSavedPaymentMethod !== undefined) {
                return lastSavedPaymentMethod;
            }
        }

        const accountSavedPaymentMethods = this.savedPaymentMethods;
        for (const paymentMethod of accountSavedPaymentMethods) {
            if (paymentMethod.id === this.selectedTopUpOption.value) {
                return paymentMethod;
            }
        }

        return undefined;
    }

    @action public handlePaymentSelectChange = (value: string): void => {
        this.selectedTopUpOption.setValue(value);
        this.selectedTopUpOption.setAsVisited();
    };
}
